import { getInitials } from "../../../../Components/InitialsAvatar";
import "./style.css"

const AVATAR_COLORS = [
  "#4F46E5",
  "#EA580C",
  "#16A34A",
  "#DC2626",
  "#2563EB",
  "#7C3AED",
];
const getAvatarColor = (name) =>
  AVATAR_COLORS[(name || "A").charCodeAt(0) % AVATAR_COLORS.length];

const formatLabel = (value) =>
  value
    ? value
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : "-";

const TopUpAvatar = ({ src, name }) =>
  src ? (
    <img
      className="top-up-company-image"
      src={src}
      alt="company-picture"
      style={{ objectFit: "cover" }}
    />
  ) : (
    <span
      className="top-up-company-image"
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 12,
        fontWeight: 700,
        color: "#fff",
        background: getAvatarColor(name),
      }}
    >
      {getInitials(name)}
    </span>
  );

const TopUpCard = ({ creditTopUps, showModal, limit }) => {
  const itemsToShow = limit ? creditTopUps.slice(0, limit) : creditTopUps;

  return (
    <div className={`top-up-card ${limit && 'top-up-card-border'}`}>
      {limit && <div className="top-up-header">Credit Top-Ups</div>}
      <div className="top-up-card-body">

        <div className="top-up-list">
          {itemsToShow.map((topUp) => (
            <div key={topUp.key} className="top-up-row">
              <div className="top-up-row-left-side">
                <TopUpAvatar src={topUp.logo} name={topUp.company} />
                <div className="top-up-details">
                  <div className="title">
                    <strong>{topUp.company}</strong>
                    <span className="method-badge">{formatLabel(topUp.method)}</span>
                  </div>
                  <div className="subtitle">Manual Credit add by Admin (2 mins ago)</div>
                </div>
              </div>
              <div className="amount">
                <span className="positive">+${topUp.amount.toLocaleString()}</span>
                <div className="period">{topUp.date} <span className="duration">{topUp.time}</span></div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {limit && creditTopUps.length > limit && (
        <div className="view-all-text" onClick={showModal}>
          View All Top Ups
        </div>
      )}
    </div>
  );
};

export default TopUpCard;
